<template>
  <Card
    v-if="showNudge"
    :class="$style.cardWrapper"
  >
    <div :class="$style.closeWrapper">
      <IconButton
        data-test-id="PaywallAbandonedNudge_closeButton"
        hasNoBackground
        icon="close"
        type="secondary"
        @click="closeNudge"
      />
    </div>
    <div>
      <div :class="$style.centerWrapper">
        <div :class="$style.highlightTagIconWrapper">
          <CustomIcon
            :class="$style.highlightTagIcon"
            :scale="1.5"
          >
            <HighlightTagIcon />
          </CustomIcon>
        </div>
      </div>
      <ParagraphBody :class="[$style.header, $style.textCenter]">
        We see you viewed <b>JumpCloud Pricing Packages.</b>
        It's not too late to make your purchase.
      </ParagraphBody>
      <div :class="$style.savingsSection">
        <ParagraphBody
          bodySize="tiny"
          :class="$style.textCenter"
        >
          <b>Consolidate all your vendors and pay up to 50% less per user.</b>
        </ParagraphBody>
        <GridAuto minWidth="4rem">
          <div
            v-for="solution in $options.solutions"
            :key="solution"
            :class="[$style.solution, $style.textCenter]"
          >
            {{ solution }}
          </div>
        </GridAuto>
        <ParagraphBody
          bodySize="large"
          :class="$style.mixedSolution"
        >
          mixed solutions
        </ParagraphBody>
        <Grid>
          <GridItem :gridSpan="6">
            <div :class="$style.jcLogoWrapper">
              <JumpcloudBrandmark
                darkBg
                :scale="2"
                type="jcLogoWordmark"
              />
            </div>
          </GridItem>
          <GridItem :gridSpan="6">
            <div :class="$style.savingsWrapper">
              <div :class="[$style.savingsCopy, $style.textCenter]">
                Savings
              </div>
              <div :class="$style.line" />
            </div>
          </GridItem>
        </Grid>
      </div>
      <div :class="[$style.goToPricingWrapper, $style.textCenter]">
        <Button
          data-test-id="PaywallAbandonedNudge_goToPricingButton"
          :text="$options.goToPricingText"
          type="primary"
          @click="goToPricing"
        />
      </div>
    </div>
  </Card>
</template>

<script>
import {
  Button,
  Card,
  CustomIcon,
  Grid,
  GridAuto,
  GridItem,
  IconButton,
  JumpcloudBrandmark,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HighlightTagIcon from 'public/img/Payments/highlight-tag.svg?inline';
import PaywallAbandonedNudgeController from 'client/components/Nudge/PaywallAbandonedNudgeController';
import Util from 'client/util/Util';

const {
  description,
  iconName,
  location,
  section,
  text,
  toUrl,
} = eventProperties;

const {
  nudgeAlert,
} = eventLocations;

export default {
  name: 'PaywallAbandonedNudge',

  goToPricingText: 'Go to Pricing',
  solutions: ['SSO', 'MFA', 'MDM', 'LDAP', 'Insights'],
  EventHelper,
  PaywallAbandonedNudgeController,
  Util,

  components: {
    Button,
    Card,
    CustomIcon,
    Grid,
    GridAuto,
    GridItem,
    HighlightTagIcon,
    IconButton,
    JumpcloudBrandmark,
    ParagraphBody,
  },

  data() {
    return {
      showNudge: true,
    };
  },

  methods: {
    closeNudge() {
      this.dismiss();
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'nudge alert for completing purchase is closed',
        [iconName]: 'close',
        [location]: nudgeAlert,
        [section]: 'Paywall abandoned nudge',
      });
    },

    dismiss() {
      this.$options.PaywallAbandonedNudgeController.dismissPaywallAbandonedNudge();
      this.showNudge = false;
    },

    goToPricing() {
      const pricingLink = ItemTypeRoutes[ItemTypeConsts.pricing];

      this.dismiss();
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'opens the pricing page.',
        [location]: nudgeAlert,
        [section]: 'Paywall abandoned nudge',
        [text]: this.$options.goToPricingText,
        [toUrl]: pricingLink,
      });

      this.$options.Util.redirect(pricingLink);
    },
  },
};
</script>

<style scoped module>
.cardWrapper {
  box-shadow: var(--jc-box-shadow-card);
  margin-top: var(--jc-spacer-small);
  position: relative;
}

.centerWrapper {
  display: flex;
  justify-content: center;
}

.closeWrapper {
  position: absolute;
  right: var(--jc-spacer);
  top: var(--jc-spacer);
}

.goToPricingWrapper,
.header.header {
  margin-top: var(--jc-spacer);
}

.highlightTagIcon {
  color: var(--jcSecondary);
}

.highlightTagIcon path {
  fill: var(--jcSecondary);
}

.highlightTagIconWrapper {
  background-color: var(--jcTertiary50);
  border: var(--jc-border-width-double) solid var(--jcTertiary50);
  border-radius: var(--jc-border-radius-large);
  padding: var(--jc-spacer-x-small);
  width: min-content;
}

.jcLogoWrapper {
  background-color: var(--jcPrimary900);
  border-radius: var(--jc-border-radius-x-small);
  padding: var(--jc-spacer-small);
  width: min-content;
}

.line {
  background:
    linear-gradient(
      var(--jcGrey300),
      var(--jcGrey300)
    ) center/100% 3px no-repeat;
  border-left: 3px solid var(--jcGrey300);
  border-right: 3px solid var(--jcGrey300);
  height: var(--jc-spacer);
}

.mixedSolution {
  background-color: var(--jcSecondary);
  border-radius: var(--jc-border-radius-x-small);
  color: var(--jcWhite50);
  padding: var(--jc-spacer-small);
}

.savingsWrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
}

.savingsCopy {
  color: var(--jcPrimary900);
}

.savingsSection {
  background-color: var(--jcPrimary100);
  margin: 0 calc(-1 * var(--card-padding));
  padding: var(--card-padding);
}

.solution {
  background-color: var(--jcGrey300);
  padding: var(--jc-spacer-x-small);
}

.textCenter {
  text-align: center;
}
</style>
